import React, { useState, useEffect } from 'react';
import { Snackbar, Alert, Button } from '@mui/material';
import WifiIcon from '@mui/icons-material/Wifi';
import WifiOffIcon from '@mui/icons-material/WifiOff';

/**
 * Компонент для отслеживания сетевого статуса и уведомления пользователя
 * Показывает уведомления при потере и восстановлении соединения
 */
const NetworkStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showOfflineAlert, setShowOfflineAlert] = useState(false);
  const [showOnlineAlert, setShowOnlineAlert] = useState(false);

  useEffect(() => {
    // Обработчики событий для отслеживания изменения статуса сети
    const handleOnline = () => {
      setIsOnline(true);
      setShowOnlineAlert(true);
    };

    const handleOffline = () => {
      setIsOnline(false);
      setShowOfflineAlert(true);
    };

    // Добавляем слушатели событий
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Удаляем слушатели при размонтировании компонента
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  // Кэширование основного контента при подключении к сети
  useEffect(() => {
    if (isOnline && 'caches' in window) {
      // Кэшируем критические ресурсы для оффлайн-доступа
      try {
        const criticalPages = ['/', '/index.html', '/offline.html'];
        const criticalAssets = [
          '/static/css/main.css',
          '/static/js/main.js',
          '/logo192.png'
        ];
        
        // Простая стратегия кэширования для демонстрации
        // В реальном проекте следует использовать workbox или service worker
        caches.open('portfolio-critical-v1').then(cache => {
          return cache.addAll([...criticalPages, ...criticalAssets]);
        });
      } catch (error) {
        console.warn('Кэширование не удалось:', error);
      }
    }
  }, [isOnline]);

  return (
    <>
      {/* Оповещение о потере соединения */}
      <Snackbar
        open={showOfflineAlert}
        autoHideDuration={6000}
        onClose={() => setShowOfflineAlert(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert 
          severity="warning" 
          variant="filled"
          icon={<WifiOffIcon />}
          action={
            <Button 
              color="inherit" 
              size="small"
              onClick={() => setShowOfflineAlert(false)}
            >
              ОК
            </Button>
          }
        >
          Вы не в сети. Некоторые функции могут быть недоступны.
        </Alert>
      </Snackbar>

      {/* Оповещение о восстановлении соединения */}
      <Snackbar
        open={showOnlineAlert}
        autoHideDuration={3000}
        onClose={() => setShowOnlineAlert(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert 
          severity="success"
          variant="filled"
          icon={<WifiIcon />}
          action={
            <Button 
              color="inherit" 
              size="small"
              onClick={() => setShowOnlineAlert(false)}
            >
              ОК
            </Button>
          }
        >
          Соединение восстановлено
        </Alert>
      </Snackbar>
    </>
  );
};

export default NetworkStatus;
